import {mapFieldArrToObjSchema} from "../../validation/useValidation";



export const FormBlogInit = {
    title: "",
    medias: [],
    category: "",
    description: "",
};

const blogValidationsArr = [
    ['name', 'string'],
];


export const blogValidations = mapFieldArrToObjSchema(blogValidationsArr);